import { useQuery } from 'react-query';
import { truckInfo } from '../../../API/TT_ELD/Users/truckInfo';
import { TableParams } from '../../../Utils/TableTypes';

export const useTruckInfo = (driverId: number): object => {
  return useQuery([`truckInfo/${driverId || 'all'}`, driverId], () => truckInfo.read(driverId), {
    refetchOnWindowFocus: false,
  });
};

export const useGetOneTruckInfo = (truckInfoId: number | undefined): any => {
  return useQuery(
    [`getOneTruckInfo/${truckInfoId || 'all'}`, truckInfoId],
    () => truckInfo.getOneTruckInfo(truckInfoId),
    { refetchOnWindowFocus: false },
  );
};

export const useGetDocuments = (
  id: string | undefined,
  userId: undefined | number | string,
  companyId: number | string,
  type: string | number,
  tableParams: TableParams,
) => {
  return useQuery(
    [`getDocuments/${id || 'all'}`, id, userId, companyId, type, tableParams],
    () => truckInfo.getDocuments(id, userId, companyId, type, tableParams),
    { refetchOnWindowFocus: false },
  );
};

export const useActionFileTypes = (enabled: boolean = true) => {
  return useQuery([`actionFileTypes/list`], () => truckInfo.getActionFileTypes(), {
    refetchOnWindowFocus: false,
    enabled,
  });
};
